import { memo, useEffect } from 'react';
import { useSendUserInput } from '../../../provider/socketContext';
import {
	useDisplayStore,
	useGoalStore,
	useSoundStore,
} from '../../../store/sceneStore';

function DestinationWidget() {
	const display = useDisplayStore();
	const { data: goal, setState: setGoal } = useGoalStore((s) => s);

	const setSound = useSoundStore((s) => s.setState);
	const sendUserInput = useSendUserInput();

	useEffect(() => {
		if (goal.dst_list.length === 0) {
			sendUserInput({
				type: 'user_input',
				text: 'DstList_request',
				value: {},
			});
		}
	}, [goal.dst_list]);

	const getGoalList = (list) => {
		if (list) {
			return list.map((dst) => {
				return (
					<button
						type='button'
						key={dst.name}
						className={`Button GoalItem`}
						style={{
							backgroundColor: `${dst.name === goal.selected_goal ? '#1b6cf1' : '#202020'}`,
							color: `${dst.name === goal.selected_goal ? '#FFFFFF' : '#505050'}`,
							margin: '0 0 12px',
						}}
						onClick={() => onClickGoal(dst.name)}
					>
						<i className={'mdi ' + dst.icn}></i>&nbsp;{dst.name}
					</button>
				);
			});
		}
	};

	const onUpdateSelectDestinationSound = () => {
		setSound({
			method: 'stop&play',
			sound_list: ['select_destination'],
			end_event: {},
		});
	};

	const onUpdateSelectGoal = (selectedGoal) => {
		if (goal.selected_goal !== selectedGoal) {
			const newGoal = { ...goal, selected_goal: selectedGoal };
			setGoal(newGoal);

			var msg = {
				type: 'user_input',
				text: 'destination',
				value: selectedGoal,
			};
			sendUserInput(msg);
		}
	};

	const onClickGoal = (selectedGoal) => {
		onUpdateSelectDestinationSound();
		onUpdateSelectGoal(selectedGoal);
	};

	if (goal.dst_mode !== 1) {
		return null;
	}

	return (
		<div className={`GoalList ${display.mode ? 'Show' : ''}`}>
			<div
				style={{
					marginTop: 'auto',
				}}
			></div>
			<button
				type='button'
				key={'blank_front'}
				className={`Button GoalItem`}
				style={{
					opacity: '0',
					margin: '0 0 12px',
				}}
			>
				{'blank'}
			</button>
			{goal.dst_list.length !== 0 ? getGoalList(goal.dst_list) : ''}
			<button
				type='button'
				key={'blank_rear'}
				className={`Button GoalItem`}
				style={{
					opacity: '0',
					margin: '0 0 12px',
				}}
			>
				{'blank'}
			</button>
			<div
				style={{
					marginBottom: 'auto',
				}}
			></div>
		</div>
	);
}

export default memo(DestinationWidget);
